import { PageProps } from 'components/page/head';
import styled from 'styled-components';

export const StyledFooter = styled('section')<PageProps>`
  background-color: ${({ cornerColorMobile }) => cornerColorMobile || '#e7e7e7'};
  @media (min-width: 641px) {
    background-color: ${({ cornerColorDesktop }) => cornerColorDesktop || '#46d281'};
`;
export const FooterContainer = styled('div')`
  background: linear-gradient(to top, #111111 0%, #231f20 100%);
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  padding: 32px;
  padding-bottom: 144px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;

  @media (min-width: 1024px) {
    grid-auto-rows: min-content;
    grid-template-columns: repeat(3, minmax(200px, 240px)) minmax(0px, 80px) minmax(360px, 600px);
    justify-content: center;
    column-gap: 0px;
    padding-bottom: 192px;
    padding-top: 128px;
  }
`;
